<template>
  <div style="margin: 16px 16px 0;">
    <v-select
      :items="items"
      item-text="title"
      item-value="id"
      :label="$t('menu.selectApp')"
      hide-details
      outlined
      @change="handleSelectedApp"
      v-model="selectedApp"
      clearable
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "AppSelect",
  data: () => ({
    loading: false,
    items: [],
    selectedApp: null
  }),
  methods: {
    getData() {
      this.loading = true;
      this.$store
        .dispatch("fetchListApp")
        .then(data => {
          this.loading = false;
          this.items = data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSelectedApp(app) {
      this.$store.dispatch("setSelectedApp", app);
      this.$root.$emit("SELECTED_APP_IS_CHANGED");
    }
  },
  mounted() {
    this.getData();
    this.selectedApp = this.$store.getters.selectedApp;
  }
};
</script>

<style scoped></style>
